import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SuperComponent } from '../../../inside.super';
import { DashboardItemDTO, DashboardItemType } from '../../../../elements.component.module/dashboard-item.component';
import { AuthService } from '../../../../services.module/auth.service';
import { Router } from '@angular/router';
import { RouteNames } from '../../../../route.name';
import { ConfigurationApiService } from '../../../../../generated/api/configuration/configuration.service';
import { Notification } from '../../../../../generated/api/kreditportalBackendAPI.schemas';
import { NotificationsService } from '../../../../providers.module/notifications.service';

@Component({
    selector: 'cockpit',
    templateUrl: './cockpit.component.html',
    styleUrls: ['./cockpit.component.less'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CockpitComponent extends SuperComponent {

    notifications: Notification[];

    numMsgs: number;

    urlNeuenVertragAbschliessen = '';

    tiles: DashboardItemDTO[] = [
        {
            // Externer Link zum VHV-Antragsformular; Link im neuen Fenster öffnen:
            // bitte folgenden Link benutzen: VARIABLE (bereits angelegt): urlNeuenVertragAbschliessen
            message: 'Neuen Vertrag abschließen',
            targetUri: 'kreditportal/vertraege',
            type: DashboardItemType.create,
        }, {
            // wenn es nur einen Vertrag gibt, direkt in diesen Vertrag springen
            // bei mehreren Verträgen in die Vertragsübersicht wechseln
            message: 'Bestehenden Vertrag anpassen',
            targetUri: 'kreditportal/vertraege',
            type: DashboardItemType.modify,
        }, {
            // Formular "Neue Bürgschaft beantragen"
            message: 'Neue Bürgschaft beantragen',
            targetUri: 'kreditportal/buergschaften/create-buergschein',
            type: DashboardItemType.delete,
        }, {
            // Formular Obligoliste anfordern
            message: 'Obligoliste anfordern',
            targetUri: 'kreditportal/buergschaften/obligo',
            type: DashboardItemType.update,
        },
    ];

    constructor(
        private readonly router: Router,
        private readonly authService: AuthService,
        private readonly configurationApiService: ConfigurationApiService,
        private readonly notificationsService: NotificationsService
    ) {
        super();

        const activeKunde = this.authService.getActiveKunde();

        // Wenn Makler, leite weiter zur Kundenauswahl
        if (activeKunde && !activeKunde.$_directKunde && !activeKunde.$_clientOfMaklerOrStbr && !activeKunde.$_clientOfFirmenverbund) {
            this.router.navigate([RouteNames.KREDIT_PORTAL_KUNDENAUSWAHL]);
        }

        this.configurationApiService.getConfiguration().subscribe(configuration => {
            this.urlNeuenVertragAbschliessen = configuration.urlNeuenVertragAbschliessen;
            this.tiles[0].targetUri = configuration.urlNeuenVertragAbschliessen;
        });

        this.notificationsService.getNachrichten().subscribe(notificationsResponse => {
            this.notifications = notificationsResponse.messages;
            this.numMsgs = notificationsResponse.messages.length;
        });
    }

}
